<template>
    <div class="vx-flex vx-flex-col vx-inset-0 vx-h-full">
        <conversation-nav class="vx-justify-between">
            <div class="vx-flex vx-gap-2 vx-items-center">
                <vx-button size="sm" color="secondary" @click="emit('close')">
                    <font-awesome-icon :icon="faArrowLeft"></font-awesome-icon>
                </vx-button>
                <span class="vx-text-base vx-text-slate-100 vx-font-extrabold vx-self-center">Edit Contact</span>
            </div>
            <vx-button size="sm" color="secondary" :href="`/contacts/${contact.id}`" target="_blank">
                Open in Voxie
                <font-awesome-icon :icon="faSquareArrowUpRight"></font-awesome-icon>
            </vx-button>
        </conversation-nav>
        <div class="vx-flex vx-flex-col vx-gap-2 vx-flex-grow vx-p-4 vx-overflow-y-auto">
            <vx-expandable-card class="vx-mx-auto lg:vx-max-w-screen-sm">
                <template v-slot:content>
                    <div class="vx-font-semibold vx-text-base vx-mb-1 vx-flex vx-items-center vx-justify-between">
                        Name:
                    </div>
                    <div class="vx-flex vx-flex-col vx-gap-4 vx-items-start">
                        <span class="vx-text-2xl vx-text-slate-500">{{ fullName }}</span>
                        <vx-button color="muted" size="md" block @click="editContactModal = true">Edit</vx-button>
                    </div>
                    <contact-edit-modal v-model="editContactModal"></contact-edit-modal>
                </template>
            </vx-expandable-card>
            <contact-view :contactId="contact.id" :allow-edit-contact="false" :allow-edit-tags="true" class="vx-mx-auto"></contact-view>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';
import { faSquareArrowUpRight, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ConversationNav from '~/components/messages/browser-extension/components/ConversationNav.vue';
import ContactEditModal from '~/components/messages/browser-extension/components/misc/ContactEditModal.vue';

import ContactView from '~/components/contacts/contact/ContactView.vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';

const emit = defineEmits(['close']);

const { fullName, contact } = useContactDetails();

const editContactModal = ref(false);

</script>
